import React from 'react'

import { Image } from '@application/Interfaces/Atoms/Image'
import { Revealer } from '@application/Interfaces/Atoms/Revealer'
import { LogosType } from '@application/Types/ComponentTypes'
import { Grid } from '@icontainers/design-system/dist/atoms/Grid'
import Container from '@mui/material/Container'

import { GridItem, Link, LogosWrapper, Title, Wrapper } from './LogosComponent.styled'

export const LogosComponent = ({ logosTitle, logos }: LogosType): JSX.Element => {
    return (
        <Wrapper>
            <Container>
                <Revealer
                    multi={{
                        delay: 150,
                    }}
                >
                    <Title>{logosTitle}</Title>
                    <LogosWrapper>
                        <Grid container alignItems="center" flexWrap="nowrap" columnSpacing={10}>
                            {logos.map((logo, i) => {
                                if (!logo.icon.localFile) return null

                                return (
                                    <GridItem item xs key={i}>
                                        <Link target="_blank" href={logo.link} rel="noreferrer">
                                            <Image image={logo.icon} />
                                        </Link>
                                    </GridItem>
                                )
                            })}
                        </Grid>
                    </LogosWrapper>
                </Revealer>
            </Container>
        </Wrapper>
    )
}
